import type { PayloadAction } from "@reduxjs/toolkit";
import { DiskWriteMode, FormatType } from "Data/Objects/Storage";
import { createAppSlice } from "Data/Redux/Store";
import type { SdCardSettingsState } from "Interfaces";

const initialState: SdCardSettingsState = {
	enableSdCardRecording: true,
	totalSize: 256,
	usedSize: 35.9,
	status: true,
	diskWriteMode: DiskWriteMode.OVERWRITE,
	storageName: "SD Card",
	formatType: FormatType.EXFAT
};

const setSdCardReducer = (state: SdCardSettingsState, action: PayloadAction<SdCardSettingsState>) => {
	return action.payload;
};

const getSdCard = (state: SdCardSettingsState) => {
	return state;
};

const sdCardSlice = createAppSlice({
	name: "sdCard",
	initialState,
	reducers: {
		setSdCardAction: setSdCardReducer
	},
	selectors: {
		selectSdCard: getSdCard
	}
});

export default sdCardSlice;

export const { setSdCardAction } = sdCardSlice.actions;
export const { selectSdCard } = sdCardSlice.selectors;
